module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/infobg.0b8a5fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/infobg.jpg
// module id = eoqg
// module chunks = 0